import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ComponentsModule, FormModule } from "@stdoutsrl/design-kit";
import { PagesComponent } from "./pages/pages.component";
import { LoginComponent } from "./login/login.component";
import { UserComponent } from "./pages/user/user.component";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { TranslocoRootModule } from "./transloco-root.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RegistrationComponent } from "./registration/registration.component";
import { ExampleMonouseComponent } from "./tables-custom-actions/example-table-component.component";
import { RecoveryPasswordComponent } from "./recovery-password/recovery-password.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { RouteReuseStrategy } from "@angular/router";
import { CustomReuseStrategy } from "./reuse";
import { LiveComponent } from "./live/live.component";
import { PresentationComponent } from "./presentation/presentation.component";
import { ContainerComponent } from "./pages/container.component";
import { Page404Component } from "./pages/page404/page404.component";
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { PlansComponent } from "./pages/plans/plans.component";
import { HomeComponent } from "./pages/home/home.component";
import { CreateQuizComponent } from "./pages/create-quiz/create-quiz.component";
import { YourQuizsComponent } from "./pages/your-quizs/your-quizs.component";
import { QRCodeComponent } from 'angularx-qrcode';
import { GoogleMapsModule } from '@angular/google-maps';
import { ModerationComponent } from "./moderation/moderation.component";
import { QuizSessionsComponent } from "./pages/quiz-sessions/quiz-sessions.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { CubeGameComponent } from "./games/cube/cube_game.component";
import { RulesComponent } from "./pages/rules/rules.component";
import { MessageComponent } from "./components/message/message.component";
import { UserRankComponent } from "./components/user-rank/user-rank.component";
import { ContainerPublicComponent } from "./pages/container-public.component";

@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    LoginComponent,
    UserComponent,
    RegistrationComponent,
    ExampleMonouseComponent,
    RecoveryPasswordComponent,
    ChangePasswordComponent,
    LiveComponent,
    ModerationComponent,
    PresentationComponent,
    ContainerComponent,
    Page404Component,
    HeaderComponent,
    FooterComponent,
    PlansComponent,
    HomeComponent,
    ContainerPublicComponent,
    CreateQuizComponent,
    YourQuizsComponent,
    QuizSessionsComponent,
    LoaderComponent,
    CubeGameComponent,
    RulesComponent,
    MessageComponent,
    UserRankComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslocoRootModule,
    ComponentsModule,
    FormModule,
    FormsModule,
    ReactiveFormsModule,
    QRCodeComponent,
    GoogleMapsModule
  ],
  providers: [provideHttpClient(withInterceptorsFromDi()),{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy }],
})
export class AppModule {}
